<template>
  <div style="max-width: 98%">
    <el-form
      :inline="true"
      :model="dataForm"
      @keyup.enter.native="getDataList()"
    >
      <div class="tool-container">
        <div>
          <el-form-item label="班级">
            <el-cascader
              style="width: 320px"
              collapse-tags
              :props="props"
              v-model="dataForm.classIdList"
              :options="gradeOptions"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="课时">
            <el-select v-model="dataForm.periodId" >
              <el-option
                v-for="item in periodDataList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="doSearch()">查询</el-button>
            <el-button type="success" @click="getExportDataList()">导出</el-button>
            <el-button @click="reset()">重置</el-button>
            
          </el-form-item>
        </div>
      </div>
    </el-form>
    <el-table :data="dataList" border v-loading="dataListLoading">
      <el-table-column
        prop="periodName"
        header-align="center"
        align="center"
        label="课时"
      >
      </el-table-column>
      <el-table-column
        prop="nickname"
        header-align="center"
        align="center"
        label="班级"
      >
        <template slot-scope="scope">
          <label class="cell"
            >{{ scope.row.gradeName }}{{ scope.row.className }}</label
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="studentName"
        header-align="center"
        align="center"
        label="学生姓名"
      >
      </el-table-column>

      <el-table-column
        prop="scoreGrade"
        header-align="center"
        align="center"
        label="成绩"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        label="提交时间"
      >
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="handlePreview(scope.row)"
            v-if="scope.row.scoreGrade"
            >查看
          </el-button>
          <el-button
            v-else
            type="text"
            size="small"
            @click="handleScore(scope.row)"
            >批阅</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
</template>

<script>
import { exportStudentTaskHomeWork } from "../../../../api/teacher/lesson-homework";
export default {
  data() {
    return {
      dataForm: {
        key: "",
      },
      props: { multiple: false },
      classMap: {},
      gradeOptions: [],
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      ruleCourseId: undefined,
      periodDataList: [],
      classIdList: undefined,
      dataForm: {
        classIdList: undefined,
        periodId: undefined
      }
    };
  },

  activated() {},
  created() {
    this.init(this.$route.query.id);
    this.getPeroidList()
    this.getCascaderList()
  },
  methods: {
    init(id) {
      this.ruleCourseId = id;
      this.getDataList();
    },
    doSearch() {
      this.pageIndex = 1
      this.getDataList();
    },
    handlePreview(item) {
      this.$router.push({
        path: "course-student-detail",
        query: { id: item.id },
      });
    },
    handleScore(item) {
      this.$router.push({
        path: "course-student-detail",
        query: { id: item.id },
      });
    },
    getDataList() {
      var classId = undefined
      if(this.dataForm.classIdList && this.dataForm.classIdList.length > 1) {
        classId = this.dataForm.classIdList[1]
      }
      this.dataListLoading = true;
      this.$http({
        url: this.$http.adornUrl("/business/lessonhomework/list_for_teacher"),
        method: "get",
        params: this.$http.adornParams({
          page: this.pageIndex,
          limit: this.pageSize,
          key: this.dataForm.key,
          classId: classId,
          periodId: this.dataForm.periodId
        }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.page.list;
          this.totalPage = data.page.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    
    getPeroidList() {
      this.$http({
        url: this.$http.adornUrl(
          "/business/rulecourse/getRuleCoursePeriodTaskList"
        ),
        method: "get",
        params: this.$http.adornParams({
          page: 1,
          limit: 999999,
          ruleCourseId: this.$route.query.id,
        }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          data.page.list.forEach(element => {
            element.name = '第' + element.index + '课时'
          });
          this.periodDataList = data.page.list;
         
        } else {
         
        }
        this.dataListLoading = false;
      });
    },
    getCascaderList() {
      this.$requst.get("/business/grade/cascaderList").then(({ data }) => {
        let arr = data.data || [];
        this.gradeOptions = data.data;
        arr.forEach((item) => {
          let child = item.children || [];
          let id1 = item.id;
          child.forEach((subItem) => {
            let id2 = subItem.id;
            // let subChild = subItem.children || []
            this.classMap["" + id2] = [id1 + "", id2 + ""];
            // subChild.forEach(cItem => {
            //     let id3 = cItem.id
            //     this.classMap["" + id3] = [id1 + "", id2 + "", id3 + ""]
            // })
          });
        });
        //this.getObjInfo();
      });
    },
   
    async getExportDataList() {
      var classId = undefined
      if(this.dataForm.classIdList && this.dataForm.classIdList.length > 1) {
        classId = this.dataForm.classIdList[1]
      }
      let params = {
          page: 1,
          limit: 999999,
          key: this.dataForm.key,
          classId: classId,
          periodId: this.dataForm.periodId
        }
      this.dataListLoading = true;
      let blobRes = await exportStudentTaskHomeWork(params);
      let blob = new Blob([blobRes.data], { type: 'application/vnd.ms-excel' });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = `学生任务单.xlsx`;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
        this.dataListLoading = false;
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    reset() {
        this.dataForm = {
        classIdList: undefined,
        periodId: undefined
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.mod-config {
  overflow: hidden;
  margin-top: 30px;
}
</style>
